export default __webpack_public_path__ + "static/404-752b2542dc23805c95008e8a058ea8ba.svg";